import c from "./index.es519.js";
import n from "./index.es520.js";
function w(e) {
  var o = e.stickyRowsCount, i = e.stickyColumnsCount, r = e.showGridLines, a = e.rightToLeft;
  if (!o && !i && r !== !1 && !a)
    return "";
  var t = "", s = {
    tabSelected: 1,
    workbookViewId: 0
  };
  r === !1 && (s.showGridLines = !1), a && (s.rightToLeft = 1);
  var f = {
    ySplit: o || 0,
    xSplit: i || 0,
    topLeftCell: c(i || 0, (o || 0) + 1),
    activePane: "bottomRight",
    state: "frozen"
  };
  return t += "<sheetViews>", t += "<sheetView".concat(n(s), ">"), t += "<pane".concat(n(f), "/>"), t += "</sheetView>", t += "</sheetViews>", t;
}
export {
  w as default
};
//# sourceMappingURL=index.es505.js.map
